<template>
    <div>
        <breeze-validation-errors class="mb-4" />

        <form @submit.prevent="submit">
            <v-text-field
                label="Name"
                type="text"
                v-model="form.name"
                required
                autofocus
                autocomplete="name"
            />

            <v-text-field
                label="Email"
                type="email"
                v-model="form.email"
                required
                autocomplete="username"
            />

            <v-text-field
                label="Password"
                type="password"
                v-model="form.password"
                required
                autocomplete="new-password"
            />

            <v-text-field
                label="Confirm Password"
                type="password"
                v-model="form.password_confirmation"
                required
                autocomplete="new-password"
            />

            <div class="flex items-center justify-end mt-4">
                <inertia-link
                    :href="route('login')"
                    class="underline text-sm text-gray-600 hover:text-gray-900"
                >
                    Already registered?
                </inertia-link>

                <breeze-button
                    class="ml-4"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                >
                    Register
                </breeze-button>
            </div>
        </form>
    </div>
</template>

<script>
import BreezeButton from "@/Components/Button";
import BreezeGuestLayout from "@/Layouts/GuestLayout";
import BreezeValidationErrors from "@/Components/ValidationErrors";

export default {
    layout: BreezeGuestLayout,

    components: {
        BreezeButton,
        BreezeValidationErrors,
    },

    data() {
        return {
            form: this.$inertia.form({
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: false,
            }),
        };
    },

    methods: {
        submit() {
            this.form.post(this.route("register"), {
                onFinish: () =>
                    this.form.reset("password", "password_confirmation"),
            });
        },
    },
};
</script>
